// src/__internal__/utils/makeRef.ts
function makeRef() {
  const ref = {
    value: null
  };
  function get() {
    return ref.value;
  }
  function set(value) {
    ref.value = value;
  }
  return [get, set];
}
export {
  makeRef
};
